import { render, staticRenderFns } from "./project-issue-c-t-d-o.vue?vue&type=template&id=2e2f1b7e"
import script from "./project-issue-c-t-d-o.vue?vue&type=script&lang=js"
export * from "./project-issue-c-t-d-o.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports